/**
 * Evita que um unico Esc faca duas coisas.
 *
 * CONSTRAINT: o rodape de formulario trata o Esc na tecla pressionada (voltar), e a janela trata o Esc na tecla
 * solta (fechar). Com um formulario aberto numa janela, o mesmo Esc voltava e fechava tudo. O rodape marca o Esc
 * que tratou e a janela ignora uma tecla solta marcada. A marca vale para um consumo e por um segundo, para que
 * uma tecla solta fora da janela nao engula o Esc seguinte.
 */
const WINDOW_MS = 1000;

let handledAt = 0;

export const markEscapeHandled = () => {
    handledAt = Date.now();
};

export const consumeEscapeHandled = () => {
    const handled = Date.now() - handledAt < WINDOW_MS;
    handledAt = 0;
    return handled;
};
